import './style.scss';

export default !function () {
  const block = document.querySelector('.price-v2');

  if (!block) {
    return;
  }

  const blockName = block.dataset.blockName || 'Блок без названия'
  const form = block.querySelector('.form');

  form?.addEventListener('form-sended', (evt) => {
    const { formData } = evt.sendingResult;
    const requestId = formData.get('request_id');

    window.$analytics?.push('price-form-send', {
      requestId,
      label: 'No options',
      blockName
    })
  });
}();
